export default __webpack_public_path__ + "static/media/gold_reveal.09376922.mp3";